// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3viZY","header":"ClearentDisclaimer_header__1zv5P","inner":"ClearentDisclaimer_inner__1J8TA"};